import { render, staticRenderFns } from "./ContractorCompanies.vue?vue&type=template&id=35cd6358"
import script from "./ContractorCompanies.vue?vue&type=script&lang=ts"
export * from "./ContractorCompanies.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35cd6358')) {
      api.createRecord('35cd6358', component.options)
    } else {
      api.reload('35cd6358', component.options)
    }
    module.hot.accept("./ContractorCompanies.vue?vue&type=template&id=35cd6358", function () {
      api.rerender('35cd6358', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/ContractorCompanies.vue"
export default component.exports